import { css } from '@emotion/react';
import { useIsCompactMode } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { useModalControl } from '@frontend/design-system';
import { APPOINTMENT_TABS } from '../constants';
import { useAppointmentAnalyticsV2ShallowStore } from '../hooks/use-appointment-analytics-v2-store';
import { FilterTrayToggle } from './atoms/filter-tray-toggle';
import { AppointmentFilterTray } from './filter-tray/appointment-filter-tray';
import { AppointmentContactTypeFilter } from './filters/appointment-contact-type-filter';
import { AppointmentLocationFilter } from './filters/appointment-location-filter';
import { AppointmentProviderFilter } from './filters/appointment-provider-filter';
import { AppointmentTimePeriodFilter } from './filters/appointment-time-period-filter';
import { ViewSwitcher } from './view-switcher';

const ignoredFilterKeys = ['locationId', 'startDate', 'endDate', 'contactType', 'provider'];

export const AppointmentAnalyticsV2TableFilters = () => {
  const { tableFilters, setTableFilters, activeTab, setFilterHintText } = useAppointmentAnalyticsV2ShallowStore(
    'tableFilters',
    'setTableFilters',
    'activeTab',
    'setFilterHintText'
  );
  const isCompactMode = useIsCompactMode();
  const { modalProps, triggerProps } = useModalControl();

  const activeFilters = tableFilters[activeTab] || {};

  const hasTrayFilters = Object.keys(activeFilters).some(
    (key) => !ignoredFilterKeys.includes(key) && activeFilters[key as keyof typeof activeFilters] !== undefined
  );

  return (
    <div css={styles.container}>
      <div css={styles.filtersWrapper}>
        {!isCompactMode && (
          <>
            <AppointmentLocationFilter
              value={activeFilters.locationId}
              onChange={(locationId) => setTableFilters({ locationId })}
            />

            <AppointmentTimePeriodFilter
              activeTab={activeTab}
              upcomingDates={tableFilters[APPOINTMENT_TABS.UPCOMING] || {}}
              pastDates={tableFilters[APPOINTMENT_TABS.PAST] || {}}
              locationId={activeFilters.locationId}
              setFilterHintText={setFilterHintText}
              onChange={(dates) => setTableFilters(dates)}
            />

            <AppointmentContactTypeFilter
              value={activeFilters.contactType}
              onChange={(contactType) => setTableFilters({ contactType })}
            />

            <AppointmentProviderFilter
              locationId={activeFilters.locationId}
              value={activeFilters.provider}
              onChange={(provider) => setTableFilters({ provider })}
            />
          </>
        )}
        <FilterTrayToggle {...triggerProps} isFilterActive={hasTrayFilters} />
      </div>
      <AppointmentFilterTray {...modalProps} />
      <ViewSwitcher />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  filtersWrapper: css`
    display: flex;
    gap: ${theme.spacing(2)};
    align-items: center;
  `,
};
